import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { Circles } from 'react-loader-spinner'
import { searchReservation } from '../../redux/actions'
import moment from 'moment'
import { useNavigate, useParams } from 'react-router-dom'
import URL from '../../constants/urls'

function FindReservation(props) {
    const{dispatch, notify} = props
    const {
      handleSubmit,
      formState: { errors },
      control,
    } = useForm()
    
    const navigate = useNavigate()
    const {partner, action} = useParams()

    const [isLoading, setIsLoading] = useState(false)
    const [reservationData, setReservationData] = useState(null)

    const onSubmit = (data) => {
        setIsLoading(true)
        dispatch(searchReservation(data)).then((res) => {
            if(res && res?.length > 0){
                setReservationData(res)
            }else{
                setReservationData(null)
                notify('error', res?.errors?.message ? res?.errors?.message : 'Reservation Details Not Found!')
            }
            setIsLoading(false)
        }).catch((err) => {
            setReservationData(null)
            notify('error', err?.errors?.message ? err?.errors?.message : 'Reservation Details Not Found!')
            setIsLoading(false)
        })
    } 

    const handleEditReservation = (Id) => {        
        if(window.location.toString().includes('iframe')){
            navigate(`/iframe/${partner}/${URL.BOOKING_EDIT_REDIRECT}/${Id}`)
        }else{
            navigate(`/${partner}/${URL.BOOKING_EDIT_REDIRECT}/${Id}`)
        }
    }

    const handleCancelReservation = (Id) => {
        if(window.location.toString().includes('iframe')){
            navigate(`/iframe/${partner}/${URL.BOOKING_CANCEL_REDIRECT}/${Id}`)
        }else{
            navigate(`/${partner}/${URL.BOOKING_CANCEL_REDIRECT}/${Id}`)
        }
    }
  

  return (
    <div style={{ minHeight: '80vh' }} className="h-100 reservation-container">
        <div className="container py-3 text-center">
            <h2 className="mt-2 text-primary">
                Find your reservation
            </h2>
            <div className='d-flex justify-content-center'>
                <div>
                    <span>
                        Find your reservation by filling out the below information.
                    </span>
                    <div className='text-left'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            
                            <div className="mb-1">
                                <label className="form-label">
                                    Booking ID <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="reservation_id"
                                    type="text"
                                    id="reservation_id"
                                    control={control}
                                    rules={{
                                    required: {
                                        value: true,
                                        message: 'This field is required',
                                    },
                                    }}
                                    render={({ field }) => (
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        {...field}
                                        id="reservation_id"
                                        placeholder="Booking ID"
                                        onChange={(e) => { field.onChange(e) }}
                                    />
                                    )}
                                />
                                {errors?.reservation_id && (
                                    <span className="text-danger small">
                                    {errors?.reservation_id?.message}
                                    </span>
                                )}
                            </div>
                        
                            <div className="mb-1">
                                <label className="form-label">
                                    Email Address{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="email"
                                    type="text"
                                    id="email"

                                    control={control}
                                    rules={{
                                    required: {
                                        value: true,
                                        message: 'This field is required',
                                    },

                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9-]+(?!.*?[.]{2})[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Please enter a valid Email Address',
                                    },
                                    }}
                                    render={({ field }) => (
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        {...field}
                                        id="email"
                                        placeholder="Email Address"
                                        onChange={(e) => { field.onChange(e) }}
                                    />
                                    )}
                                />
                                {errors?.email && (
                                    <span className="text-danger small">
                                    {errors?.email?.message}
                                    </span>
                                )}
                            </div>
                            
                            <button
                                className="btn btn-primary x d-none d-sm-block btn-sm"
                                disabled={isLoading}
                                type="submit"
                                name="submit"
                            >
                            <div className='d-flex  justify-content-center align-items-centerd'>
                                <span>
                                    Submit
                                </span>
                                <span className="ms-2">
                                    {isLoading ? (
                                        <Circles
                                        height="20"
                                        width="20"
                                        style={{ display: 'inline-block' }}
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                        />
                                    ) : null}
                                </span>
                            </div>
                            </button>
                        </form>
                    </div>
                    {reservationData?.id ?
                        <div className="my-4">
                            <div className="card border-0 shadow-sm">
                                <div className="bg-primary rounded-top" style={{height: '4px'}}></div>

                                    <div className="card-body px-4 py-3">
                                    <div className="d-flex justify-content-between flex-wrap mb-4">
                                        <div className='text-start'>
                                            <div className="text-uppercase text-muted small mb-1">
                                                Booking ID
                                            </div>
                                            <div className="fs-5 fw-bold text-dark">
                                                {reservationData?.ticketech_code}
                                            </div>
                                        </div>

                                        <div className="text-end mt-3 mt-md-0">
                                            <div className="text-uppercase text-muted small mb-1">
                                                Email ID
                                            </div>
                                            <div className="fs-6 fw-semibold text-primary">
                                                {reservationData?.email}
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="my-3"/>
                                    <div className="d-flex justify-content-between flex-wrap">
                                        <div className='text-start'>
                                            <div className="text-muted small mb-1">
                                                Start Date / Time
                                            </div>
                                            <div className="fw-semibold">
                                                {moment(reservationData?.start_timestamp).format('DD/MM/YYYY hh:mm:ss')}
                                            </div>
                                        </div>

                                        <div className="text-end mt-3 mt-md-0">
                                            <div className="text-muted small mb-1">
                                                End Date / Time
                                            </div>
                                            <div className="fw-semibold">
                                                {moment(reservationData?.end_timestamp).format('DD/MM/YYYY hh:mm:ss')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer bg-transparent border-0 pt-0 px-4 pb-3">
                                    <div className="d-flex justify-content-end">
                                        {action == 'edit' ? 
                                        <button className="btn btn-primary px-4" type='button' onClick={() => {handleEditReservation(reservationData?.id)}}>
                                            Edit Reservation
                                        </button>
                                        : 
                                        <button className="btn btn-primary px-4" type='button' onClick={() => {handleCancelReservation(reservationData?.id)}}>
                                            Cancel Reservation
                                        </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                </div>
            </div>
        </div>
    </div>
  )
}

FindReservation.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
}

FindReservation.defaulProps = {
  dispatch: noop,
  notify: noop,
}

function mapStateToProps({ userDetailsReducer }) {
  return {
    loader: userDetailsReducer?.loader,
  }
}
export default connect(mapStateToProps)(FindReservation) 